import React from 'react';
import * as ReactQuery from 'react-query';

export const withQuery = ({ useQuery }) => (Component: React.ComponentType) =>
  function Wrapped(props) {
    const query = useQuery();

    return <Component {...props} {...query} />;
  };

export const withHooks = (hooks: Record<string, () => unknown>) => (
  Component: React.ComponentType,
) =>
  function Wrapped(props) {
    const hookMap = {};
    for (const [hookKey, hook] of Object.entries(hooks)) {
      hookMap[hookKey] = hook();
    }
    return <Component {...props} {...hookMap} />;
  };

export const withQueries = (queries: {
  [key: string]: () =>
    | ReactQuery.UseQueryResult
    | ReactQuery.UseInfiniteQueryResult;
}) => (Component: React.ComponentType) => withHooks(queries)(Component);
